import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/button-has-type */
import { forwardRef } from 'react';
import classnames from 'classnames';
import { ButtonType } from '../../enums';
const PureButton = forwardRef(({ children, className, type = ButtonType.Button, ...restLinkProps }, ref) => (_jsx("button", { className: classnames('theme-remove-button-styles', className), ref: ref, type: type, ...restLinkProps, children: children })));
PureButton.displayName = PureButton.name;
export { PureButton };
